import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import "./index.css";

import App from "./App.tsx";

const originalConsoleLog = console.log;
const originalConsoleError = console.error;
const originalConsoleTrace = console.trace;
const originalConsoleWarn = console.warn;

const cloudflarePatterns = [
  "RqWO: sjnn",
  "challenges.cloudflare.com",
  "Feature Policy:",
  "Window.fullScreen attribute is deprecated",
  "InstallTrigger is deprecated",
  "onmozfullscreenchange is deprecated",
  "onmozfullscreenerror is deprecated",
  "Quirks Mode",
  "Private Access Token challenge",
  "Partitioned cookie or storage access",
];

const shouldFilterCloudflare = (args: unknown[]): boolean => {
  const stringified = args
    .map((arg) => (typeof arg === "string" ? arg : JSON.stringify(arg)))
    .join(" ");

  return cloudflarePatterns.some((pattern) => stringified.includes(pattern));
};

console.log = function (...args: unknown[]) {
  if (shouldFilterCloudflare(args)) return;
  originalConsoleLog.apply(console, args);
};

console.error = function (...args: unknown[]) {
  if (shouldFilterCloudflare(args)) return;
  originalConsoleError.apply(console, args);
};

console.trace = function (...args: unknown[]) {
  if (shouldFilterCloudflare(args)) return;
  originalConsoleTrace.apply(console, args);
};

console.warn = function (...args: unknown[]) {
  if (shouldFilterCloudflare(args)) return;
  originalConsoleWarn.apply(console, args);
};

async function initializeApp() {
  /**
   * ACUL Integration Note:
   * The following lines handle the specific way this React application is integrated
   * into Auth0's Universal Login page. Auth0 provides the base HTML DOM.
   * This script then creates a 'div' (rootElement),
   * appends it to Auth0's document.body, and then mounts the React application onto this div.
   * This differs from typical setups where an index.html is bundled directly with the app.
   */
  const rootElement = document.createElement("div");
  rootElement.id = "root";

  document.body.appendChild(rootElement);

  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

initializeApp();
